/**
 * Normalizes cart payloads from AJAX responses.
 * Supports wrapped ({ cart: "..." }), double-encoded JSON strings, and plain cart objects.
 */
export function parseCartResponse(data) {
    if (data == null) {
        return null;
    }

    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        } catch (e) {
            return null;
        }
    }

    if (typeof data === 'object') {
        if (data.success === false) {
            return null;
        }

        if (Object.prototype.hasOwnProperty.call(data, 'cart')) {
            return parseCartResponse(data.cart);
        }

        if (Object.prototype.hasOwnProperty.call(data, 'id') && Object.prototype.hasOwnProperty.call(data, 'rows')) {
            return data;
        }
    }

    return null;
}

export function serializeCartForEvent(cart) {
    return JSON.stringify(cart);
}
